/** @jsxRuntime classic */
/** @jsx jsx */

import { FC, Fragment, useState } from 'react';
import { jsx, Theme } from '@emotion/react';

import { DraggableSlot } from './DraggableSlot';
import { MoreSlotsButton } from '../MoreSlotsButton';
import { MoreSlotsList } from '../MoreSlotsList';
import { ECalendarMode, IEventComponentProps, ISlotsGroup } from '../../types';
import { collisionGroupContainer } from '../styles';
import { ISlot } from '../../../organisms/bo_calendar_slot/types';

const MAX_COUNT = 4;

interface ISlotGroupProps {
	group: ISlotsGroup;
	withModal: boolean;
	index: number;
	id: string;
	EventComponent: FC<IEventComponentProps>;
	colors: Theme;
	currentDate: string;
	mode?: ECalendarMode;
	updateSlotData: (id: number, updatedSlot: Partial<ISlot>, data: any) => void;
}

export const SlotGroups = ({
	group,
	withModal,
	index,
	id,
	EventComponent,
	colors,
	currentDate,
	mode,
	updateSlotData,
}: ISlotGroupProps) => {
	const moreItemsCount = withModal ? group.groups!.slice(3).reduce((acc, events) => acc + events.length, 0) : 0;
	const [open, setOpen] = useState(false);

	return (
		<div
			id={`group-${index}`}
			key={index}
			css={collisionGroupContainer(group.top, group.height)}
			data-aid="SlotGroup-daily"
		>
			{group.groups?.map((groupItems, index) => {
				return (
					<Fragment key={`SlotGroup-${index}`}>
						{groupItems.map(event => {
							return (
								<DraggableSlot
									key={`SlotGroup-${event.id}`}
									slot={event}
									parentId={id}
									EventComponent={EventComponent}
									groupTop={group.top}
									groupCount={withModal ? MAX_COUNT : group.groups?.length}
									groupIndex={index}
									currentDate={currentDate}
									mode={mode}
									updateSlotData={updateSlotData}
								/>
							);
						})}
					</Fragment>
				);
			})}
			{withModal && (
				<MoreSlotsButton
					colors={colors}
					handleToggleModal={() => setOpen(prev => !prev)}
					moreItemsCount={moreItemsCount}
				/>
			)}
			{withModal && open && (
				<MoreSlotsList
					colors={colors}
					EventComponent={EventComponent}
					group={group}
					handleToggleModal={() => setOpen(prev => !prev)}
					index={index}
					currentDate={currentDate}
					mode={mode}
					horizontal={false}
				/>
			)}
		</div>
	);
};
